//#region import libraries
import React, { useState } from 'react';
//custom component
import { TableHeader } from "_molecules";
//styles
import { Colors } from '_styles';
// icons
import { BsChevronRight, BsChevronLeft } from "react-icons/bs";
//#endregion

const toEuroString = (cents) => {
    let euro = cents / 100;
    let euroString = euro.toLocaleString("en-US", { style: "currency", currency: "EUR" });
    return euroString
}

const addressElement = (address) => {
    if (address) {
        return (

            <div style={{ height: 80, textOverflow: 'ellipsis', overflow: 'auto', margin: 0, padding: 0, width: '100%' }}>
                <p style={{ fontSize: 16, opacity: 0.7, fontWeight: '300', textAlign: 'center', marginTop: 0 }}>
                    <>
                        <span>{address.line1}</span><br />
                        {address.line2 ? <span>{address.line2}</span> : <></>}
                        <span>{address.city}</span><br />
                        <span>{address.country}</span><br />
                        <span>{address.postal_code}</span><br />
                        {address.state != 'string' ? <><span>{address.state}</span><br /></> : <></>}
                    </>
                </p>
            </div>
        )
    } else {
        return (
            <span>Address not available</span>
        )
    }
}

const timeElement = (time) => {
    if (time) {
        time = time.split(', ')
        return <>
            <span>{time[0]}</span>
            <br />
            <span>{time[1]}</span>
        </>
    }
}

const TransactionTable = (props) => {

    const [index, setIndex] = useState(0)

    const getSubset = () => {
        let list = props.list.slice(index * 5, (index * 5) + 5)
        return list
    }

    const canDoNextPage = () => {
        let nextIndex = index + 1
        let list = props.list.slice(nextIndex * 5, (nextIndex * 5) + 5)
        return list.length != 0
    }

    if (props.list.length) {
        return (
            <div style={{ boxShadow: "0px 4px 8px 2px #9E9E9E", borderRadius: '10px', padding: 12, width: '100%', tableLayout: 'fixed', borderColor: Colors.PRM_LIGHT_BLUE }}>
                <table width={'100%'}>
                    <tr style={{ BORDERcOLOR: Colors.PRM_LIGHT_BLUE }}>
                        <th style={{ padding: 12 }}><TableHeader title={"Units Sold"} /></th>
                        <th style={{ padding: 12 }}><TableHeader title={"Total"} /></th>
                        <th style={{ padding: 12 }}><TableHeader title={"Date"} /></th>
                        <th style={{ padding: 12 }}><TableHeader title={"Delivery Type"} /></th>
                        <th style={{ padding: 12 }}><TableHeader title={"Address"} /></th>
                    </tr>

                    {
                        getSubset().map((row) => {
                            return (
                                <tr style={{ borderBottomStyle: 'solid', borderTopStyle: 'solid', borderBottomWidth: 0.1, borderTopWidth: 0.1, borderBottomColor: Colors.PRM_LIGHT_BLUE }}>
                                    <td style={{ fontWeight: '200', fontSize: 18, paddingLeft: 6, textAlign: 'center' }}>{row.numberSold}</td>
                                    <td style={{ fontWeight: '200', fontSize: 18, paddingLeft: 6, textAlign: 'center' }}>{toEuroString(row.amount)}</td>
                                    <td style={{ fontWeight: '200', fontSize: 18, paddingLeft: 6, textAlign: 'center' }}>{timeElement(row.dateSoldString)}</td>
                                    <td style={{ fontWeight: '200', fontSize: 18, paddingLeft: 6, textAlign: 'center' }}>{row.selectedDistribution ? row.selectedDistribution : "Delivery type not available"}</td>
                                    <td style={{ fontWeight: '200', fontSize: 18, paddingLeft: 6, textAlign: 'center' }}>{addressElement(row.address)}</td>
                                </tr>
                            )
                        })
                    }
                </table>

                {/* Pagination Clicker */}
                <div style={{ justifyContent: 'right', marginTop: 20, display: 'flex' }}>
                    <p style={{ opacity: 0.6, fontWeight: '200', fontSize: 18, marginRight: 18, marginBottom: 4 }}>{((index * 5) + 1)} - {(index * 5) + 5}, of {props.list.length}</p>
                    <BsChevronLeft onClick={() => { index == 0 ? null : setIndex(index - 1) }} size={20} style={{ cursor: 'pointer' }} color='#307FE2' />
                    <BsChevronRight onClick={() => { !canDoNextPage() ? null : setIndex(index + 1) }} size={20} style={{ marginLeft: 12, cursor: 'pointer' }} color='#307FE2' />
                </div>
            </div>
        );
    } else {
        return (
            <p style={{ fontSize: 18, fontWeight: '600', opacity: 0.6 }}></p>
        )
    }
}

export default TransactionTable;